import React, {useEffect} from "react";
import {Outlet} from "react-router-dom";
import AOS from "aos";
import Header from "../components/Header";
import Footer from "../components/Footer";

const MainLayout = () => {

    useEffect(() => {
        AOS.init({duration: 1000, once: true});
    }, []);

    return (
        <div className="d-flex flex-column min-vh-100">
            <Header/>
            <main style={{minHeight: 'calc(100vh - 175px)'}}>
                <Outlet/>
            </main>
            <Footer/>
        </div>
    );
};

export default MainLayout;
